export type WayletExternosTipo = 'pago' | 'devolver' | 'cancelar';

export interface WayletClienteApi {
  Id: string;
  Token: string;
}

export interface WayletExternosConfig {
  conexionIacpos: string | number;
  empresaClave: string;
  proyectoNombre: string;
  pasarelaEntorno: string;
  clienteApi: WayletClienteApi;
}

export function resolveWayletPasarelaEntorno(chEntornoConexion?: string): string {
  const entorno = (chEntornoConexion || 'DESARROLLO').toUpperCase();
  if (entorno.includes('PRE')) {
    return 'WAYLETPREPRODUCCION';
  }
  if (entorno.includes('PRO')) {
    return 'WAYLETPRODUCCION';
  }
  return 'WAYLETDESARROLLO';
}

export function readWayletClienteApi(): WayletClienteApi | null {
  try {
    const id = localStorage.getItem('credentialId');
    const tokenRaw = localStorage.getItem('currentToken');
    if (!id || !tokenRaw) {
      return null;
    }
    const parsed = JSON.parse(tokenRaw);
    const token = parsed?.token ?? parsed?.Token ?? '';
    if (!token) {
      return null;
    }
    return { Id: id, Token: token };
  } catch {
    return null;
  }
}

export function readConexionIacpos(): string | number {
  const raw = localStorage.getItem('conexionId');
  if (!raw) {
    return '';
  }
  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
}

export interface BuildWayletExternosParams {
  paymentId: string;
  amountCentimos?: number;
  qrContent?: string;
  wayletPaymentId?: string;
  items?: unknown[];
}

export function buildWayletExternosBody(
  config: WayletExternosConfig,
  tipo: WayletExternosTipo,
  params: BuildWayletExternosParams
): Record<string, unknown> {
  const base = {
    clienteApi: config.clienteApi,
    conexionIacpos: config.conexionIacpos,
    EmpresaClave: config.empresaClave,
    ProyectoNombre: config.proyectoNombre,
    PasarelaEntorno: config.pasarelaEntorno,
  };

  if (tipo === 'cancelar') {
    return {
      ...base,
      ObjetoGenerar: {
        paymentId: params.paymentId,
      },
    };
  }

  if (tipo === 'devolver') {
    return {
      ...base,
      ObjetoGenerar: {
        paymentId: params.paymentId,
        amount: params.amountCentimos ?? 0,
        items: params.items ?? [],
      },
    };
  }

  return {
    ...base,
    ObjetoGenerar: {
      paymentId: params.paymentId,
      wayletPaymentId: params.wayletPaymentId || '',
      qrContent: params.qrContent || '',
      amount: params.amountCentimos ?? 0,
      items: params.items ?? [],
    },
  };
}
